/**
 * Requested sudoku type, mirroring the backend SudokuVariantRequest enum.
 * MIXED picks a random type for every puzzle of a set (out of the variants
 * the server-side generator implements).
 */
export type SudokuType = 'CLASSIC' | 'EVEN_ODD' | 'X' | 'JIGSAW' | 'KILLER' | 'MIXED';

/**
 * Selector options in display order.
 */
export const SUDOKU_TYPE_OPTIONS: SudokuType[] = ['CLASSIC', 'EVEN_ODD', 'X', 'JIGSAW', 'KILLER', 'MIXED'];

export const SUDOKU_TYPE_LABELS: Record<SudokuType, string> = {
  CLASSIC: 'Классический',
  EVEN_ODD: 'Чёт-нечет',
  X: 'Х',
  JIGSAW: 'Паззл',
  KILLER: 'Киллер',
  MIXED: 'Микс',
};

/**
 * Resolves the selector options from the server-provided allowed list
 * (clientInfo.sudokuAllowedTypes), keeping display order and dropping unknown
 * names. While the list has not loaded yet all options are offered; a list that
 * filters down to nothing falls back to classic.
 */
export const resolveSudokuTypeOptions = (allowedTypes?: string[]): SudokuType[] => {
  if (!allowedTypes) {
    return SUDOKU_TYPE_OPTIONS;
  }
  const options: SudokuType[] = SUDOKU_TYPE_OPTIONS.filter((type: SudokuType) => allowedTypes.includes(type));
  return options.length > 0 ? options : ['CLASSIC'];
};
